import React, { useState } from 'react';
import { CoverPhotoPresentation } from './coverphoto-presentation';
import { getCroppedImg } from '@constants/canvautils';
import getBase64 from '@sharedComponent/base-64';
import { message } from 'antd';
import Axios from 'axios';
import { appConstant, apiUrl } from '@constants';
import { useHistory } from 'react-router-dom';
import { getAuthToken, getAuthKey } from '@helpers';

export const CoverPhotoFunctional = () => {
	const history = useHistory();
	const [state, setState] = useState({
		imageSrc: null,
		crop: { x: 0, y: 0 },
		zoom: 1,
		croppedImage: null,
		croppedAreaPixels: { width: 0, height: 0, x: 0, y: 0 },
		basecroppedImage: null,
		rotation: 0,
	});

	const crop = (crp) => {};

	const zoom = (zoom) => {};

	const setZoom = (setZoom) => {};

	const setCrop = (setCrop) => {
		setState({
			...state,
			crop: setCrop,
		});
	};

	const onCropComplete = (croppedArea, croppedAreaPixels) => {
		new Promise((resolve) => {
			setState({
				...state,
				croppedAreaPixels: croppedAreaPixels,
			});
			resolve(croppedAreaPixels);
		}).then((croppedAreaPixels) => {
			getCrappedImage(croppedAreaPixels);
		});
	};

	const getCrappedImage = async (croppedAreaPixels) => {
		try {
			const { croppedImage, basecroppedImage } = await getCroppedImg(state.imageSrc, croppedAreaPixels, state.rotation);
			setState({ ...state, croppedImage, basecroppedImage });
		} catch (e) {}
	};

	const handleChange = (label, value) => {
		setState({
			...state,
			[label]: value,
		});
	};

	const cancel = () => {
		setState({
			imageSrc: null,
			crop: { x: 0, y: 0 },
			zoom: 1,
			croppedImage: null,
			croppedAreaPixels: { width: 0, height: 0, x: 0, y: 0 },
			basecroppedImage: null,
			rotation: 0,
		});
	};

	const upload = async () => {
		const authToken = await getAuthToken();
		const authKey = await getAuthKey();
		if (state.basecroppedImage) {
			Axios.put(
				`${appConstant.domain + apiUrl.UPLOAD_COVER_PHOTO}`,
				{ authKey: authKey, coverImage: state.basecroppedImage },
				{ headers: { Authorization: authToken } }
			).then((res) => {
				if (res.data.success) {
					message.success('Cover photo uploaded');
					history.push('/dashboard');
					window.location.reload();
				}
			});
		} else {
			message.error('Please click browse media to uplaod  new image');
		}
	};

	const fileChange = async (e, id) => {
		// if (e.target.files && e.target.files[0] && e.target.files[0].size / 1024 <= 1025) {
		// message.warn('Please wait while your image checks for nudity');
		// message.warn('Please wait...');
		let file = await e.target.files[0];
		// let imageSize = await getImageSize(file);
		// if (imageSize.currentImageWidth >= 800) {
		let isNudeValue = false;
		// let isNudeValue = await isNude(file);
		if (!isNudeValue) {
			await setState({ ...state, imageSrc: window.URL.createObjectURL(file) });
		} else {
			message.error('Nudity and Partial Nudity images are not allowed');
		}
		// }
		// } else {
		// 	message.error('file size must be less than 1 mb');
		// }
	};

	const getImageSize = async (file) => {
		let currentImageWidth = 0;
		let currentImageheight = 0;
		var img = await new Image();
		return new Promise(async (resolve) => {
			var objectUrl = await window.URL.createObjectURL(file);
			img.onload = await function () {
				currentImageWidth = this.width;
				currentImageheight = this.height;
				// alert(currentImageWidth + ' ' + currentImageheight);
				window.URL.revokeObjectURL(objectUrl);
				resolve({ currentImageheight, currentImageWidth });
			};
			img.src = await objectUrl;
		}).then((res) => {
			return { currentImageheight: res.currentImageheight, currentImageWidth: res.currentImageWidth };
		});
	};

	const isNude = async (file) => {
		let base64 = await getBase64(file).then((res) => {
			return res;
		});
		const deepai = require('deepai'); // OR include deepai.min.js as a script tag in your HTML
		// deepai.setApiKey('quickstart-QUdJIGlzIGNvbWluZy4uLi4K');
		deepai.setApiKey('fb333df1-33d2-406a-b75e-c88637c38354');
		var resp = await deepai.callStandardApi('nsfw-detector', {
			image: base64,
		});

		return (await resp.output.nsfw_score) > 0.5;
	};

	return (
		<CoverPhotoPresentation
			onCropComplete={onCropComplete}
			crop={crop}
			setCrop={setCrop}
			zoom={zoom}
			getImageSize={getImageSize}
			setZoom={setZoom}
			state={state}
			upload={upload}
			handleChange={handleChange}
			fileChange={fileChange}
			cancel={cancel}
		/>
	);
};
